<template>
  <div>
    <modal ref="modal" :closeable="true">
      <h3>Domain sign up</h3>
      <p>This feature allows anyone with the email domain <strong>{{'@' + domain}}</strong> to join your team when they sign up for TunnelBear.</p>
    </modal>
    <onboard-wrap>
      <h1>Your team is ready!</h1>
      <ul class="check-list promo-list">
        <li v-if="invitedCount > 0">
          <strong>{{invitedCount}} invite<span v-if="invitedCount > 1">s</span></strong> sent.
          <router-link :to="{name: 'account-invite'}">Invite More</router-link>
        </li>
        <li>
          Email confirmation sent<span v-if="email"> to <strong class="email">{{email}}</strong></span>.
        </li>
        <li v-if="domain">
          Check your email to activate <button @click="openModal()" class="btn link plain">Domain Sign Up</button>.
        </li>
      </ul>
      <p>If you haven't already, this is a good time to download the apps for yourself.</p>
      <div class="btn-wrap">
        <a href="/download" class="btn btn-lg">Download Apps</a>
        <p class="subtext">Or view <router-link :to="{name: 'team'}">your team</router-link></p>
      </div>
    </onboard-wrap>
  </div>
</template>

<script>
import modal from '@/components/modal/modal'
import onboardWrap from '@/components/team-wrap/team-wrap'

export default {
  name: 'done',
  components: {
    'modal': modal,
    'onboard-wrap': onboardWrap
  },
  data () {
    return {}
  },
  created: function () {
    this.$store.dispatch('getUserData').then(() => {
      this.$store.dispatch('validateDomain')
    })
    this.$store.dispatch('getTeamData')
  },
  computed: {
    invitedCount: function () {
      return this.$store.state.newTeam.inviteCount
    },
    email: function () {
      return this.$store.getters.userData.user
    },
    domain: function () {
      return this.$store.getters.domain || ''
    }
  },
  methods: {
    openModal: function () {
      this.$refs.modal.openModal()
    }
  },
  beforeMount: function () {}
}
</script>

<style scoped lang="stylus" src="./done.styl" >



// WEBPACK FOOTER //
// src/views/start/views/done/done.vue